import { render, staticRenderFns } from "./KullanimSartlari.vue?vue&type=template&id=3afc665e&"
import script from "./KullanimSartlari.vue?vue&type=script&lang=js&"
export * from "./KullanimSartlari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports